import { useCallback, useEffect, useState } from "react";

import { getSubmissions } from "src/api/client";

const LEGACY_KEY_PREFIXES = ["walkin:insurance_submitted:", "walkin:consents_agreed:"];

function clearLegacyKeys() {
  try {
    const keys = Object.keys(window.localStorage);
    for (const key of keys) {
      if (LEGACY_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        window.localStorage.removeItem(key);
      }
    }
  } catch {
    // ignore storage access errors (e.g. private browsing)
  }
}

export function useSubmissions(clientId: string, streamToken: string, enabled: boolean) {
  const [insuranceCardSubmitted, setInsuranceCardSubmitted] = useState(false);
  const [consentsSubmitted, setConsentsSubmitted] = useState(false);

  useEffect(clearLegacyKeys, []);

  useEffect(() => {
    if (!enabled || !clientId || !streamToken) return;
    let cancelled = false;

    // OR with the current value: a request already in flight may predate a submission just made.
    function refresh() {
      getSubmissions(clientId, streamToken)
        .then((s) => {
          if (cancelled) return;
          setInsuranceCardSubmitted((prev) => prev || s.insuranceCardSubmitted);
          setConsentsSubmitted((prev) => prev || s.consentsSubmitted);
        })
        .catch(() => {});
    }
    function onVisible() {
      if (document.visibilityState === "visible") refresh();
    }

    refresh();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [clientId, streamToken, enabled]);

  const markInsuranceSubmitted = useCallback(() => setInsuranceCardSubmitted(true), []);
  const markConsentsSubmitted = useCallback(() => setConsentsSubmitted(true), []);

  return {
    insuranceCardSubmitted,
    consentsSubmitted,
    markInsuranceSubmitted,
    markConsentsSubmitted,
  };
}
